import { FETCH_SAF_SAVE_DRAFT_LOADING, FETCH_SAF_SAVE_DRAFT_DONE,
  FETCH_SAF_SAVE_DRAFT_ERROR, POST_SAF_SAVE_DRAFT_LOADING,
  POST_SAF_SAVE_DRAFT_DONE, POST_SAF_SAVE_DRAFT_ERROR,
  POST_SAF_CONSIGNEE_DONE, POST_SAF_CONSIGNEE_ERROR, POST_SAF_CONSIGNEE_LOADING,
  FETCH_SAF_CONSIGNEE_DONE, FETCH_SAF_CONSIGNEE_ERROR, FETCH_SAF_CONSIGNEE_LOADING,
  FETCH_SAF_SHIPPER_DONE, FETCH_SAF_SHIPPER_ERROR, FETCH_SAF_SHIPPER_LOADING,
  EDIT_SAF_CONSIGNEE_DONE, EDIT_SAF_CONSIGNEE_ERROR, EDIT_SAF_CONSIGNEE_LOADING,
  DELETE_SAF_CONSIGNEE_DONE, DELETE_SAF_CONSIGNEE_ERROR, DELETE_SAF_CONSIGNEE_LOADING,
  POST_SAF_SUBMIT_DONE, POST_SAF_SUBMIT_ERROR, POST_SAF_SUBMIT_LOADING,
  FETCH_SAF_BANK_DONE, FETCH_SAF_BANK_ERROR, FETCH_SAF_BANK_LOADING,
  DOWNLOAD_SAF_DOCUMENT_DONE, DOWNLOAD_SAF_DOCUMENT_ERROR, DOWNLOAD_SAF_DOCUMENT_LOADING,
  UPLOAD_SAF_DOCUMENT_DONE, UPLOAD_SAF_DOCUMENT_ERROR, UPLOAD_SAF_DOCUMENT_LOADING,
  DOWNLOAD_SAF_DOCUMENT_APPROVED_DONE, DOWNLOAD_SAF_DOCUMENT_APPROVED_ERROR, DOWNLOAD_SAF_DOCUMENT_APPROVED_LOADING
} from './actions'

export default {
  [FETCH_SAF_SAVE_DRAFT_LOADING] (state) {
    state.isLoadingSaf = true
  },

  [FETCH_SAF_SAVE_DRAFT_DONE] (state, saf) {
    state.saf = saf
    state.isLoadingSaf = false
  },

  [FETCH_SAF_SAVE_DRAFT_ERROR] (state, errorSaf) {
    state.errorSaf = errorSaf
    state.isLoadingSaf = false
  },

  [POST_SAF_SAVE_DRAFT_LOADING] (state) {
    state.isLoadingPostsaf = true
    state.isErrorPostsaf = {}
    state.postsaf = {}
  },

  [POST_SAF_SAVE_DRAFT_DONE] (state, postsaf) {
    state.postsaf = postsaf
    state.isLoadingPostsaf = false
  },

  [POST_SAF_SAVE_DRAFT_ERROR] (state, isErrorPostsaf) {
    state.isErrorPostsaf = isErrorPostsaf
    state.isLoadingPostsaf = false
  },

  [FETCH_SAF_CONSIGNEE_LOADING] (state) {
    state.isLoadingConsignee = true
  },

  [FETCH_SAF_CONSIGNEE_DONE] (state, consignee) {
    state.consignee = consignee
    state.isLoadingConsignee = false
  },

  [FETCH_SAF_CONSIGNEE_ERROR] (state, errorConsignee) {
    state.errorConsignee = errorConsignee
    state.isLoadingConsignee = false
  },

  [FETCH_SAF_SHIPPER_LOADING] (state) {
    state.isLoadingShipper = true
  },

  [FETCH_SAF_SHIPPER_DONE] (state, shipper) {
    state.shipper = shipper
    state.isLoadingShipper = false
  },

  [FETCH_SAF_SHIPPER_ERROR] (state, errorShipper) {
    state.errorShipper = errorShipper
    state.isLoadingShipper = false
  },

  [POST_SAF_CONSIGNEE_LOADING] (state) {
    state.isLoadingPostconsignee = true
  },

  [POST_SAF_CONSIGNEE_DONE] (state, postconsignee) {
    state.postconsignee = postconsignee
    state.isLoadingPostconsignee = false
  },

  [POST_SAF_CONSIGNEE_ERROR] (state, isErrorPostconsignee) {
    state.isErrorPostconsignee = isErrorPostconsignee
    state.isLoadingPostconsignee = false
  },

  [EDIT_SAF_CONSIGNEE_LOADING] (state) {
    state.isLoadingEditconsignee = true
  },

  [EDIT_SAF_CONSIGNEE_DONE] (state, editconsignee) {
    state.editconsignee = editconsignee
    state.isLoadingEditconsignee = false
  },

  [EDIT_SAF_CONSIGNEE_ERROR] (state, isErrorEditconsignee) {
    state.isErrorEditconsignee = isErrorEditconsignee
    state.isLoadingEditconsignee = false
  },

  [DELETE_SAF_CONSIGNEE_LOADING] (state) {
    state.isLoadingDeleteconsignee = true
  },

  [DELETE_SAF_CONSIGNEE_DONE] (state, deleteconsignee) {
    state.deleteconsignee = deleteconsignee
    state.isLoadingDeleteconsignee = false
  },

  [DELETE_SAF_CONSIGNEE_ERROR] (state, isErrorDeleteconsignee) {
    state.isErrorDeleteconsignee = isErrorDeleteconsignee
    state.isLoadingDeleteconsignee = false
  },

  [POST_SAF_SUBMIT_LOADING] (state) {
    state.isLoadingPostSubmit = true
  },

  [POST_SAF_SUBMIT_DONE] (state, postsubmit) {
    state.postsubmit = postsubmit
    state.isLoadingPostSubmit = false
  },

  [POST_SAF_SUBMIT_ERROR] (state, isErrorPostSubmit) {
    state.isErrorPostSubmit = isErrorPostSubmit
    state.isLoadingPostSubmit = false
  },

  [FETCH_SAF_BANK_LOADING] (state) {
    state.isLoadingBank = true
  },

  [FETCH_SAF_BANK_DONE] (state, bank) {
    state.bank = bank
    state.isLoadingBank = false
  },

  [FETCH_SAF_BANK_ERROR] (state, errorBank) {
    state.errorBank = errorBank
    state.isLoadingBank = false
  },

  [DOWNLOAD_SAF_DOCUMENT_LOADING] (state) {
    state.isLoadingDocSaf = true
  },

  [DOWNLOAD_SAF_DOCUMENT_DONE] (state, docSaf) {
    state.docSaf = docSaf
    state.isLoadingBank = false
  },

  [DOWNLOAD_SAF_DOCUMENT_ERROR] (state, errorDocSaf) {
    state.errorDocSaf = errorDocSaf
    state.isLoadingDocSaf = false
  },

  [UPLOAD_SAF_DOCUMENT_LOADING] (state) {
    state.isLoadingUploadDocSaf = true
  },

  [UPLOAD_SAF_DOCUMENT_DONE] (state, uploaddocSaf) {
    state.uploaddocSaf = uploaddocSaf
    state.isLoadingUploadDocSaf = false
  },

  [UPLOAD_SAF_DOCUMENT_ERROR] (state, errorUploadingDocSaf) {
    state.errorUploadingDocSaf = errorUploadingDocSaf
    state.isLoadingUploadingDocSaf = false
  },

  [DOWNLOAD_SAF_DOCUMENT_APPROVED_LOADING] (state) {
    state.isLoadingDocSafApproved = true
  },

  [DOWNLOAD_SAF_DOCUMENT_APPROVED_DONE] (state, docSafApproved) {
    state.docSafApproved = docSafApproved
    state.isLoadingDocSafApproved = false
  },

  [DOWNLOAD_SAF_DOCUMENT_APPROVED_ERROR] (state, errorDocSafApproved) {
    state.errorDocSafApproved = errorDocSafApproved
    state.isLoadingDocSafApproved = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/saf/mutations.js